import { render, staticRenderFns } from "./Suspended.vue?vue&type=template&id=59d2531d&scoped=true&"
var script = {}
import style0 from "./Suspended.vue?vue&type=style&index=0&id=59d2531d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d2531d",
  null
  
)

export default component.exports